// routes/_app.bot.discord.landing.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/_app.bot.discord.landing')

export const handle = { name: 'bot/discord/landing' }

export default dynamic(getClientModule, { ssr: false })
